import script from "./VecuraPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VecuraPage.vue?vue&type=script&setup=true&lang=ts"

import "./VecuraPage.vue?vue&type=style&index=0&id=4f1be2ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f1be2ba"]])

export default __exports__